import { Menu } from "@headlessui/react";
import { FC } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import FilterMenu from "./filter-menu";

import { ActionType, getSortKeys, Sort } from "@interfaces/filters";
import { useFilters } from "@context/filter";

const SortFilter: FC = () => {
  const { filters, dispatch } = useFilters();
  const router = useRouter();
  const { t } = useTranslation("category", { keyPrefix: "filters.sort" });

  const handleClick = async (value: Sort) => {
    dispatch({
      type: ActionType.SET_SORT,
      value,
    });

    await router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        sort: value.toLowerCase(),
      },
    });
    router.reload();
  };

  return (
    <FilterMenu
      {...{
        text: `${t("sort-by")}: ${t(filters.sortType)}`,
        className: "flex-col max-w-max divide-y-2 divide-gray-400 py-1 z-30",
      }}
    >
      {getSortKeys().map((current) => (
        <Menu.Item key={current} disabled={filters.sortType === Sort[current]}>
          {({ active, disabled }) => (
            <button
              className={`text-left py-2 px-4 w-full transition-all duration-200
            ${active ? "bg-gray-400" : ""}
            ${disabled ? "text-gray-400" : ""}`}
              onClick={() => handleClick(Sort[current])}
            >
              {t(current)}
            </button>
          )}
        </Menu.Item>
      ))}
    </FilterMenu>
  );
};

export default SortFilter;
